var DependencyViewController = function ($scope, $http) {
    var cacheBust = new Date().getTime();

    $http.get("versions.json" + "?cb=" + cacheBust).success(function (data) {
        $scope.projectName = data["name"];
        $scope.projectVersion = data["version"];
        var dependencies = data["dependencies"];

        for (var key in dependencies) {
            var obj = dependencies[key];
        }

        $scope.tree = dependencies;
    });

    //$scope.itemId = 1;
    $scope.isExpand = false;

    $scope.itemClick = function (name, expand) {
        $scope.itemName = name;
        $scope.isExpand = !expand;
    };

    //The canvas icons must be loaded before the css scripts.
    var icons = require("./CanvasIcons");
    icons();

    var css = require("./Gridcss");
    css();
};

DependencyViewController.$inject = ["$scope", "$http"];

export default DependencyViewController;
